import { render } from "./LessonSuspense.vue?vue&type=template&id=6705f9f8"
import script from "./LessonSuspense.vue?vue&type=script&lang=js"
export * from "./LessonSuspense.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\aarhondakis\\Desktop\\lernapp_quellcode\\lernapp-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__